import { type ActiveState, createEntityStore, type EntityState, type HashMap } from '@datorama/akita';
import { type KpiField, type KpiFieldGroupRow } from 'types/models';

export interface KPIFieldsState extends EntityState<KpiField>, ActiveState {
   entities: HashMap<KpiField>;
   entitiesWithValues: KpiField[];
   entitiesTableColumns: KpiField[];
   activeEntity: KpiField | null;
   activeMeta: any;
   activeFieldGroup: Pick<
      KpiField,
      | 'id'
      | 'slug'
      | 'key'
      | 'kpiContentId'
      | 'reportingStandardId'
      | 'isRequired'
      | 'individualGuidanceDefaultExpanded'
      | 'consolidationMethod'
      | 'allowAddOnDataChildOrganisations'
   > | null;
   activeRow: KpiFieldGroupRow | null;
   isLoading: boolean;
   isValidationRulesLoading: boolean;
}

const store = createEntityStore<KPIFieldsState>(
   {
      activeMeta: null,
      activeFieldGroup: null,
      activeRow: null,
   },
   { resettable: true, name: 'kpiFields' }
);

const defaults = () => ({ isExpanded: false, showFormula: false });
store.createUIStore().setInitialEntityState(defaults);

export default store;
